import { createRouter, createWebHistory } from 'vue-router'
import { authService } from '../services/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/import',
    name: 'Import',
    component: () => import('../views/Import.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/practice',
    name: 'Practice',
    component: () => import('../views/Practice.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/review',
    name: 'Review',
    component: () => import('../views/Review.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: () => import('../views/UserManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('../views/ChangePassword.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  // 检查路由是否需要认证
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  
  if (!requiresAuth) {
    // 不需要认证的路由直接放行
    next()
    return
  }
  
  // 检查用户是否已登录
  const isLoggedIn = authService.isLoggedIn()
  
  if (!isLoggedIn) {
    // 未登录，重定向到登录页
    next({ name: 'Login' })
    return
  }
  
  // 如果需要管理员权限，检查用户是否为管理员
  if (requiresAdmin && !authService.isAdmin()) {
    // 不是管理员，重定向到首页
    next({ name: 'Home' })
    return
  }
  
  // 已登录且权限满足，放行
  next()
})

export default router